/**
 * Modelos de `GET /perron-coins/settings` (A0 de Perrón Coins, spec `perron-coins-plan.md` de la API, D7-D8 y
 * M-JSON-1). La respuesta de la API (snake_case) se normaliza en `PerronCoinsSettingsService`: aquí solo vive la
 * forma ya limpia que consume la web.
 */

/** Los 8 flags de módulos, en el orden de `PerronCoinsSetting::MODULES` de la API (D7). */
export const PERRON_COINS_MODULE_KEYS = [
  'raffles',
  'opportunities',
  'coin_payments',
  'campaigns',
  'collaborations',
  'referrals',
  'top_perron',
  'birthdays',
] as const;

export type PerronCoinsModuleKey = (typeof PERRON_COINS_MODULE_KEYS)[number];

/** Ajustes ya normalizados: valor de canje de 1 Coin en CRC enteros (> 0) y los 8 flags en booleano estricto. */
export interface PerronCoinsSettings {
  coinValueCrc: number;
  modules: Record<PerronCoinsModuleKey, boolean>;
}

/**
 * Módulos que la web SABE pintar (D7): el flag de la API es intención de negocio, y la web solo pinta un módulo
 * cuando su código está desplegado. En A0 no hay ninguno; cada madre (B1 rifas, B2 oportunidades, B3 pago con
 * Coins…) añade aquí el suyo en su addenda, junto con la sección que lo pinta.
 */
export const PERRON_COINS_KNOWN_MODULES: readonly PerronCoinsModuleKey[] = [];

/** Módulos de `known` (en su orden) con el flag a `true`. Un flag activo cuyo código no conoce la web no sale. */
export function activeKnownModules(
  settings: PerronCoinsSettings,
  known: readonly PerronCoinsModuleKey[] = PERRON_COINS_KNOWN_MODULES,
): PerronCoinsModuleKey[] {
  return known.filter((key) => settings.modules[key] === true);
}
